import React from 'react';
import { Clock, MapPin } from 'lucide-react';
import styles from './CounselorCard.module.css';

const CounselorCard = ({ counselor, onClick }) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={styles.profileImageContainer}>
        <div className={styles.profileImagePlaceholder}></div>
      </div>
      <h3 className={styles.name}>{counselor.name}</h3>
      <p className={styles.title}>{counselor.title}</p>
      <div className={styles.experience}>
        <Clock size={14} className={styles.icon} />
        <span>{counselor.experience}</span>
      </div>
      <div className={styles.specialties}>
        {counselor.specialties.map((specialty, index) => (
          <span key={index} className={styles.specialtyTag}>
            {specialty}
          </span>
        ))}
      </div>
      <div className={styles.bottomRow}>
        <div className={styles.location}>
          <MapPin size={14} className={styles.icon} />
          <span>{counselor.location}</span>
        </div>
        <div className={styles.rate}>
          ${counselor.hourlyRate}/hour
        </div>
      </div>
      <button className={styles.ctaButton}>
        Check Availability
      </button>
    </div>
  );
};

export default CounselorCard;

